import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

/**
 * Consistent empty / "no endpoint yet" panel for learner pages and tabs.
 *
 *   <EmptyState icon={faBook} title="Nothing here yet" hint="…" />
 */
const EmptyState = ({icon, title, hint, action}) => (
  <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-14 text-center">
    {icon ? <FontAwesomeIcon icon={icon} className="h-6 w-6 text-slate-400" /> : null}
    <p className="m-0 text-sm font-semibold text-slate-700">{title}</p>
    {hint ? <p className="m-0 max-w-md text-xs text-slate-500">{hint}</p> : null}
    {action ? <div className="mt-2">{action}</div> : null}
  </div>
);

export default EmptyState;
